const doWindow = window;
export default class SlpNoResultsForm {
    constructor() {
        this.setFormVisibility = (visible) => visible
            ? this._form.parentElement.removeAttribute("hidden")
            : this._form.parentElement.setAttribute("hidden", "true");
        this.setupLead = () => {
            doWindow.DealeronLead.addSubmissionMethod("noResultsSubmitMethod", {
                additionalData: (form) => {
                    let altDealerId = undefined;
                    let comments = "";
                    const childDealerField = form["ChildDealerId"];
                    if (childDealerField) {
                        const childDealerId = childDealerField.value;
                        const childDealerName = childDealerField.options[childDealerField.selectedIndex]
                            .textContent;
                        comments = `ChildDealerName: ${childDealerName}, ChildDealerId: ${childDealerId}`;
                    }
                    else if (form["AltDealerId"]) {
                        altDealerId = form["AltDealerId"].value;
                    }
                    const ccpaField = form.querySelector("[name='DoNotSellPersonalInfo']");
                    if (ccpaField) {
                        comments += `, Do Not Sell Personal Info: ${ccpaField.checked}`;
                    }
                    return {
                        AltDealerId: altDealerId,
                        Comments: comments,
                    };
                },
            });
            doWindow.DealeronLead.initialize("#emptyResultsForm", "noResultsSubmitMethod");
            const fnameField = this._form.querySelector("[name='FirstName']");
            fnameField?.addEventListener("blur", () => doWindow.DealeronLead.begin(), {
                once: true,
            });
        };
        this._form = document.getElementById("emptyResultsForm");
        this.setupLead();
    }
}
